import { useNavigate } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { useNotificationUnreadCount } from '../hooks/useNotifications'
import { useLanguage } from '../hooks/useLanguage'

export function NotificationBell() {
  const navigate = useNavigate()
  const { t } = useLanguage()
  const { data } = useNotificationUnreadCount()
  const unreadCount = data?.unread_count || 0

  return (
    <button
      type="button"
      onClick={() => navigate('/notifications')}
      className="relative flex h-8 w-8 items-center justify-center rounded-full text-gray-700 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/30 dark:text-gray-200 dark:hover:bg-gray-800"
      aria-label={t(`通知，${unreadCount} 条未读`, `Notifications, ${unreadCount} unread`)}
    >
      <Bell className="h-[19px] w-[19px]" strokeWidth={2} />
      {unreadCount > 0 && (
        <span className="absolute -right-1 -top-1 flex min-h-[17px] min-w-[17px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white dark:ring-gray-900">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  )
}
